import request from '@/utils/request'

export function getHomeData () {
  return request({
    url: '/index/index',
    method: 'get'
  })
}

export function getFooterData () {
  return request({
    url: '/index/footer_data',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/home.js